import styles from "./policy.module.css";

const AccountDeletionPolicy = () => {
    return (
        <div className={styles["terms-container"]}>
            <p style={{ fontFamily: "Comfortaa", fontSize: "16px" }}>
                <h1><span>USER DATA DELETION POLICY</span></h1>

                At Sekeron, we are dedicated to protecting your privacy and ensuring you have full control over your personal data. If you wish to delete your account and all associated data, you can easily do so by following the steps below.

                <h2>How to Delete Your Account and Data</h2>
                If you would like to permanently delete your account and remove all associated data, please follow these steps:
                <h5>
                <ol start={1} style={{ marginLeft: '20px' }}>
                    <li style={{ listStyleType: 'decimal' }}>Sign In to Your Account:</li>
                </ol>
                </h5>              
                
                
                <li>Visit <a href="https://sekeron.com">Sekeron</a> and sign in using your registered email and password.
                </li>
                <h5>
                <ol start={2} style={{ marginLeft: '20px' }}>
                    <li style={{ listStyleType: 'decimal' }}>Navigate to Profile Security:</li>
                </ol>
                </h5>     

                <li>After logging in, go to your <span>Profile section</span>.</li>
                <li>Select <span>Settings</span> from the dropdown menu.</li>
                <li>Under <span>Settings</span>, click on <span>Profile Security</span>.</li>
                <h5>
                <ol start={3} style={{ marginLeft: '20px' }}>
                    <li style={{ listStyleType: 'decimal' }}>Delete Your Account:</li>
                </ol>
                </h5>  
                <li>In the <span>Profile Security</span> section, you will find the option to <span>Delete My Account</span>.</li>
                <li>  Click on <span>Delete My Account</span> and confirm your decision to permanently delete your account and all associated data.</li>
                <h5>
                <ol start={4} style={{ marginLeft: '20px' }}>
                    <li style={{ listStyleType: 'decimal' }}> Confirmation of Deletion:</li>
                </ol>
                </h5> 
                <li>Once you confirm, we will begin the process of permanently deleting your account.</li>
                <li>Your account and all associated data will be deleted from our system within <span>30 days</span>.</li>
                <li>You will receive a confirmation email once your account has been successfully deleted.</li>            
               
                <h5>Important Notes:</h5>
                <li>Deleting your account will result in the removal of all personal data, including your profile information, posts, and interactions with other users on the platform.</li>
                <li>Please be aware that once your data is deleted, it <span>cannot be recovered</span>.</li>
                <li>We may retain certain data for legal or compliance purposes, but this data will no longer be associated with your identity.</li>
           
                <h3>Need Help?</h3>
                If you encounter any issues while attempting to delete your account, please contact our support team at <a href="mailto:support@sekeron.com">support@sekeron.com</a>.
            </p>
        </div>
    );
}
export default AccountDeletionPolicy;